import { useEffect, useRef } from "react";

const ACTIVITY_EVENTS = ["pointermove", "keydown", "touchstart", "scroll"] as const;

type Options = {
  enabled: boolean;
  timeoutMs: number;
  onIdle: () => void;
};

/**
 * Сброс таймера по активности пользователя; по истечении timeoutMs вызывает onIdle.
 */
export function useIdleTimer({ enabled, timeoutMs, onIdle }: Options): void {
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  useEffect(() => {
    if (!enabled || timeoutMs <= 0) return;

    let timer: ReturnType<typeof setTimeout> | null = null;

    const arm = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => onIdleRef.current(), timeoutMs);
    };

    arm();
    for (const ev of ACTIVITY_EVENTS) {
      window.addEventListener(ev, arm, { passive: true });
    }
    document.addEventListener("visibilitychange", arm);

    return () => {
      if (timer) clearTimeout(timer);
      for (const ev of ACTIVITY_EVENTS) {
        window.removeEventListener(ev, arm);
      }
      document.removeEventListener("visibilitychange", arm);
    };
  }, [enabled, timeoutMs]);
}
